module.exports = __webpack_public_path__ + "static/media/sujala.195a322c.png";